import React, {useEffect, useState} from "react";
import CalendarWidget from "./Widgets/CalendarWidget/Calendar";
import {actions as oppertunitiesActions, selectors as opportunitySelectors} from '../../../Ducks/opportunity';
import {selectors as accountSelectors} from '../../../Ducks/account';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getWeekStartEndDate} from "../../Utils/dateUtils";
import {FOLLOW_UP} from "../../Utils/constants";
import {Box, Grid, IconButton} from "@mui/material";
import PersonOverviewTab from "./Tabs/PersonOverviewTab";
import {Close} from "@mui/icons-material";
import {LoadingButton} from "@mui/lab";

function Calendar(props) {
    const {cronofyAuthorized, getAllEvents, getAllEvenets_inProgress, calendar, events, followUps} = props;
    const [legacyEvents, setLegacyEvents] = useState([]);
    const [legacyFollowUps, setLegacyFollowUps] = useState([]);
    const [selectedFollowUp, setSelectedFollowUp] = useState(null);
    const [dateRange, setDateRange] = useState({});
    const [gridOneHeight, setGridOneHeight] = useState(null);

    useEffect(() => {
        if (cronofyAuthorized) {
            const currentWeek = getWeekStartEndDate(new Date());
            setDateRange(currentWeek);
            getAllEvents(currentWeek);
        }
    }, [cronofyAuthorized, getAllEvents]);

    useEffect(() => {
        if (calendar) {
            if (Array.isArray(calendar)) {
                setLegacyEvents(calendar);
            } else if (calendar) {
                setLegacyEvents([calendar]);
            }
        }
    }, [calendar]);

    useEffect(() => {
        if (followUps) {
            if (Array.isArray(followUps)) {
                setLegacyFollowUps(followUps);
            } else if (followUps) {
                setLegacyFollowUps([followUps]);
            }
        }
    }, [followUps]);

    const handleAppointmentChange = (selectedAppointment) => {
        if (selectedAppointment.event_type === FOLLOW_UP) {
            setSelectedFollowUp(selectedAppointment);
            let calendarWidgetHeight = document.getElementsByClassName('calendarWidget')[0];
            setGridOneHeight(calendarWidgetHeight.offsetHeight);
        }
    }

    return (
        <>
            <div style={{textAlign: 'right', marginBottom: '1rem'}}>
                <LoadingButton onClick={() => getAllEvents(dateRange)}
                               loading={getAllEvenets_inProgress} variant="outlined">
                    Refresh
                    Actions
                </LoadingButton>
            </div>
            <Grid container>
                <Grid className="calendarWidget" item xs={selectedFollowUp ? 6 : 12} sx={{padding: 1}}>
                    <CalendarWidget {...props} events={cronofyAuthorized ? events : []}
                                    legacy_events={legacyEvents} follow_ups={legacyFollowUps}
                                    appointmentChangeCallback={handleAppointmentChange}
                                    setDateRange={setDateRange}
                                    selectedFollowUp={selectedFollowUp}/>
                </Grid>
                {
                    selectedFollowUp && <Grid item xs={6} sx={{padding: 1}}>
                        <Grid item xs={12} sx={{
                            textAlign: 'right',
                            backgroundColor: "white",
                            borderRadius: "4px"
                        }}>
                            <IconButton onClick={() => setSelectedFollowUp(null)}>
                                <Close/>
                            </IconButton>
                        </Grid>
                        <Box sx={{
                            overflowY: 'auto',
                            backgroundColor: "rgb(239, 239, 239)",
                            borderRadius: "4px"
                        }} style={{ height: selectedFollowUp && gridOneHeight ? `${gridOneHeight}px` : "auto" }}>
                            <Grid container>
                                    <PersonOverviewTab person={selectedFollowUp}/>
                                </Grid>
                        </Box>
                    </Grid>
                }
            </Grid>

        </>
    );
}

const mapStateToProps = (state) => ({
    calendar: opportunitySelectors.calendar(state),
    events: opportunitySelectors.events(state),
    followUps: opportunitySelectors.followUps(state),
    getAllEvenets_inProgress: opportunitySelectors.getAllEvenets_inProgress(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getAllEvents: oppertunitiesActions.getAllEvents,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
